import styled from 'styled-components'

export const AuthWrapper = styled.div`
  height: 100%;
  max-width: 340px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`

export const FormHeader = styled.div`
`

export const FormTitle = styled.h1`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;

  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.black};
`

export const FormSubtitle = styled(FormTitle)`
  font-weight: 400;
  font-size: 10px;
  margin-top: 14px;
  margin-bottom: 16px;
  text-transform: none;
`
export const PageTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 22px;
  border-bottom: 2px solid #E9EAED;
  color: #1890FF;

  span {
    border-bottom: 2px solid #1890FF;
    display: inline-block;

    margin-bottom: 7px;
    padding-bottom: 7px;
  }
`
